import { useCallback, useEffect } from 'react';

const DEFAULT_TITLE = 'CRM Ergeon';

/**
 * Hook for updating page title when customer responds
 */
const usePageTitleNotification = () => {
  const notify = useCallback((customerName: string) => {
    document.title = `💬 ${customerName} - ${DEFAULT_TITLE}`;
  }, []);

  const reset = useCallback(() => {
    document.title = DEFAULT_TITLE;
  }, []);

  useEffect(() => {
    const handleFocus = () => {
      reset();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [reset]);

  return { notify, reset };
};

export default usePageTitleNotification;
